import { Component } from '@angular/core';

@Component({
  selector: 'app-password-reset-successfully',
  templateUrl: './password-reset-successfully.component.html',
  styleUrls: ['./password-reset-successfully.component.scss']
})
export class PasswordResetSuccessfullyComponent {

}
